import { useState } from 'react';

import { IoEyeSharp } from 'react-icons/io5';

import Button from '#globalComponents/Button/Button';
import { useAuth } from '#globalContexts/AuthProvider';
import { authClient } from '#lib/authClient';

// Driven by the impersonated_by JWT claim (not local state) so it survives
// reloads and cannot get out of sync with the actual session. Deliberately not
// dismissible: impersonation must stay visible for its entire duration.
const ImpersonationBanner = () => {
	const { impersonatedBy, user } = useAuth();
	const [stopping, setStopping] = useState(false);

	if (!impersonatedBy) return null;

	const handleStop = async () => {
		setStopping(true);
		// Result is irrelevant: if the impersonated session already expired, the
		// reload lands on the login page — same outcome as a successful stop.
		await authClient.admin.stopImpersonating();
		window.location.assign('/admin/accounts');
	};

	return (
		<div className="flex items-center justify-center gap-3 bg-accent px-4 py-2.5 text-text text-sm">
			<IoEyeSharp className="hidden sm:block text-lg shrink-0" />

			<span className="text-center">
				<strong>Support-Modus:</strong> Sie sehen den Account von <strong>{user?.email}</strong>.
			</span>

			<Button
				variant="solid"
				shape="pill"
				size="sm"
				className="shrink-0"
				onClick={handleStop}
				disabled={stopping}
			>
				Beenden
			</Button>
		</div>
	);
};

export default ImpersonationBanner;
